export var IdGameTrackingFpsEventName;
(function (IdGameTrackingFpsEventName) {
    IdGameTrackingFpsEventName["GAME_JOINED"] = "GAME_JOINED";
    IdGameTrackingFpsEventName["TUTORIAL_STARTED"] = "TUTORIAL_STARTED";
    IdGameTrackingFpsEventName["FIRST_TUTORIAL_BUTTON_CLICKED"] = "FIRST_TUTORIAL_BUTTON_CLICKED";
    IdGameTrackingFpsEventName["X_MINUTE"] = "{X}_MINUTE";
})(IdGameTrackingFpsEventName || (IdGameTrackingFpsEventName = {}));



//////////////////
// WEBPACK FOOTER
// ./src/features/game-tracking/fps/IdGameTrackingFpsEventName.ts
// module id = 415
// module chunks = 3